import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {VueJsonp} from 'vue-jsonp';
import { Toast, Field , Button, ImagePreview, Dialog} from 'vant';
import 'vant/lib/index.css';

Vue.prototype.$toast = Toast;
Vue.config.productionTip = false
Vue.use(Field)

Vue.prototype.ImagePreview = ImagePreview
Vue.prototype.Dialog = Dialog
Vue.use(VueJsonp)
Vue.use(Button)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
